import React from 'react';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '../ui/dialog';
import { Button } from '../ui/button';
import { Sparkles } from 'lucide-react';

export default function AiMembershipRenewalDialog({
  open,
  onOpenChange,
  expiryDate,
  websiteUrl,
}) {
  const expiryStr = expiryDate
    ? new Date(expiryDate).toLocaleDateString(undefined, { dateStyle: 'medium' })
    : null;
  const href =
    websiteUrl &&
    (String(websiteUrl).startsWith('http')
      ? websiteUrl
      : `https://${String(websiteUrl).replace(/^\/+/, '')}`);

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-md" data-testid="ai-renewal-dialog">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2">
            <Sparkles className="w-5 h-5 text-violet-600 shrink-0" />
            Renew AI membership
          </DialogTitle>
          <DialogDescription asChild>
            <div className="text-left space-y-3 pt-1 text-sm text-muted-foreground">
              <p className="text-foreground">
                AI chat and voice features only work when your AI plan is active. Renew to keep using the assistant.
              </p>
              {expiryStr && (
                <p>
                  <span className="font-medium text-foreground">Previous plan ended:</span>{' '}
                  {expiryStr}
                </p>
              )}
              <p>
                Renew in the mobile app if you use in-app purchases, or contact your dietitian / admin.
                {href ? (
                  <>
                    {' '}
                    You can also visit{' '}
                    <a
                      href={href}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="text-primary underline underline-offset-2 font-medium"
                    >
                      the program website
                    </a>
                    .
                  </>
                ) : null}
              </p>
            </div>
          </DialogDescription>
        </DialogHeader>
        <DialogFooter>
          <Button type="button" onClick={() => onOpenChange(false)}>
            Got it
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
